import { render, staticRenderFns } from "./tbFrmHealthSocialCareResourceUse.vue?vue&type=template&id=bea58362"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports